// src/components/TermsAndConditions.js

import React from 'react';

const TermsAndConditions = () => {
    return (
        <main className="bg-slate-50 pt-28 md:pt-40 pb-20">
            <div className="max-w-4xl mx-auto px-6">
                
                {/* Page Header */}
                <div className="text-center mb-16">
                    <div className="inline-flex items-center gap-2 bg-white border border-slate-200 px-4 py-2 rounded-full mb-6 shadow-sm">
                        <svg className="w-3 h-3 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                        <span className="text-[10px] font-black tracking-[0.2em] text-brand-dark uppercase">Legal Document</span>
                    </div>
                    <h1 className="text-4xl md:text-5xl font-black text-brand-dark tracking-tighter uppercase">
                        Terms & Conditions
                    </h1>
                </div>

                {/* Main Content Wrapper */}
                <div className="space-y-10">
                    <p className="text-slate-700 text-justify leading-loose">
                        These Terms & Conditions govern your use of Acadfinity’s hiring and recruitment services. By accessing or submitting information through the Careers platform, you agree to these Terms.
                    </p>

                    {/* Section 1 */}
                    <div>
                        <h2 className="text-2xl font-black text-brand-dark mb-4">1. Nature of Service</h2>
                        <p className="text-slate-700 text-justify leading-loose">
                            Acadfinity is an Authorized School Hiring & Talent Acquisition Partner that facilitates connections between:
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-slate-700 text-justify leading-loose mt-4">
                            <li>Educational Institutions (“Institutions”)</li>
                            <li>Educators & school professionals (“Candidates”)</li>
                        </ul>
                        <p className="text-slate-700 text-justify leading-loose mt-4">
                            Acadfinity is not a job guarantee platform and does not issue employment offers.
                        </p>
                    </div>

                    {/* Section 2 */}
                    <div>
                        <h2 className="text-2xl font-black text-brand-dark mb-4">2. Candidate Responsibilities</h2>
                        <p className="text-slate-700 text-justify leading-loose">
                            By submitting your profile, you agree that:
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-slate-700 text-justify leading-loose mt-4">
                            <li>All information provided is accurate and truthful.</li>
                            <li>You understand that job selection and hiring decisions rest solely with schools.</li>
                            <li>Acadfinity does not charge candidates any registration or placement fees.</li>
                            <li>Interview calls and offers are made directly by schools.</li>
                        </ul>
                    </div>
                    
                    {/* Section 3 */}
                    <div>
                        <h2 className="text-2xl font-black text-brand-dark mb-4">3. Institutional Responsibilities</h2>
                        <p className="text-slate-700 text-justify leading-loose">
                            Institutions using the Service agree that:
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-slate-700 text-justify leading-loose mt-4">
                            <li>They are authorized representatives of their schools.</li>
                            <li>Candidate data will be used only for recruitment purposes.</li>
                            <li>Hiring decisions, background checks, salary offers, and employment terms are solely their responsibility.</li>
                            <li>Acadfinity is not liable for post-hiring performance or employment outcomes.</li>
                        </ul>
                    </div>

                    {/* Section 4 */}
                    <div>
                        <h2 className="text-2xl font-black text-brand-dark mb-4">4. Intellectual Property</h2>
                        <p className="text-slate-700 text-justify leading-loose">
                            All content, branding, platform design, and materials are the exclusive property of Acadfinity. Unauthorized use, duplication, or misrepresentation is prohibited.
                        </p>
                    </div>

                    {/* Section 5 */}
                    <div>
                        <h2 className="text-2xl font-black text-brand-dark mb-4">5. Limitation of Liability</h2>
                        <p className="text-slate-700 text-justify leading-loose">
                            Acadfinity shall not be liable for:
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-slate-700 text-justify leading-loose mt-4">
                            <li>Employment decisions made by schools.</li>
                            <li>Salary negotiations or job outcomes.</li>
                            <li>Any indirect or consequential losses arising from platform usage.</li>
                        </ul>
                    </div>
                    
                    {/* Section 6 */}
                    <div>
                        <h2 className="text-2xl font-black text-brand-dark mb-4">6. Governing Law & Jurisdiction</h2>
                        <p className="text-slate-700 text-justify leading-loose">
                            These Terms shall be governed by the laws of India, with exclusive jurisdiction in the courts of Jodhpur, Rajasthan.
                        </p>
                    </div>

                    {/* Section 7 */}
                    <div>
                        <h2 className="text-2xl font-black text-brand-dark mb-4">7. Modifications</h2>
                        <p className="text-slate-700 text-justify leading-loose">
                            Acadfinity reserves the right to update these Terms at any time. Continued use of the Service implies acceptance of revised Terms.
                        </p>
                    </div>
                    
                    {/* Section 8 - Highlighted Contact Box */}
                    <div className="!mt-12 bg-slate-100/70 p-6 rounded-xl">
                        <h2 className="text-2xl font-black text-brand-dark mb-3">8. Contact</h2>
                        <p className="text-slate-700 leading-relaxed">
                            For support or legal queries:
                            <a href="mailto:careers@acadfinity.com" className="font-semibold text-brand-orange hover:underline ml-2">
                                📧 careers@acadfinity.com
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default TermsAndConditions;